// libraries.
import { Form } from 'react-bootstrap';
import { useDebounce } from '@uidotdev/usehooks';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// slices.
import {
  getMedianZoneCode,
  setMedianZoneCode,
} from '../../store/slices/medianZones.slice';

// styles.
import { WrapperMedianZone } from './styles';

export const InputMedianZone = ({ onChange }: { onChange: () => void }) => {
  const dispatch = useDispatch();
  const medianZoneCode = useSelector(getMedianZoneCode);

  const [zoneCode, setZoneCode] = useState<string>('');
  const debouncedZoneCode = useDebounce(zoneCode, 1000);

  useEffect(() => {
    setZoneCode(medianZoneCode || '');
  }, [medianZoneCode]);

  useEffect(() => {
    if (debouncedZoneCode) {
      dispatch(setMedianZoneCode(debouncedZoneCode));
    }
  }, [debouncedZoneCode, dispatch]);

  return (
    <WrapperMedianZone className="p-3">
      <Form.Group controlId="formBasicEmail">
        <Form.Label>Zonas medianas</Form.Label>
        <Form.Control
          type="text"
          placeholder="Zona mediana"
          value={zoneCode || ''}
          onChange={e => {
            setZoneCode(e.target.value);
            onChange();
          }}
        />
      </Form.Group>
    </WrapperMedianZone>
  );
};
